import r from "../managers/braze-instance.js";
import nr from "./feature-flags-provider-factory.js";
export function getFeatureFlag(t) {
  if (!r.rr()) return;
  const e = r.v();
  if (e && !e.ke()) return null;
  const n = nr.m().Me();
  return n[t] ? n[t] : null;
}
